@if (element$ | async; as element) {
  <div class="sis-sismap-sidepane-div" [ngClass]="className$ | async">
    <ion-header>
      <ion-toolbar>
        <ion-row>
          <ion-col class="icon-col"
            ><div class="icon-div icon-div-asset-type" [innerHTML]="assetTypeIcon$ | async"></div
          ></ion-col>
          <ion-col
            ><div class="header-title-text">
              @if (element.label) {
                <span>{{ element.label }} - </span>
              }
              <span>{{ element.name }}</span>
            </div>
          </ion-col>
        </ion-row>
      </ion-toolbar>
    </ion-header>
    <ion-content [forceOverscroll]="false">
      <div class="content-div">
        @if (element.status && element.status !== 0) {
          <ion-row>
            <ion-col>
              @switch (element.status) {
                @case (2) {
                  <div>
                    <span class="status-box open-status" translate>webreport.term.open</span>
                    @switch (element.subStatus) {
                      @case (201) {
                        <span class="sub-status" translate>general.term.circulation</span>
                      }
                      @case (202) {
                        <span class="sub-status" translate>general.term.convoy</span>
                      }
                    }
                  </div>
                }
                @case (1) {
                  <div>
                    <span class="status-box closed-status" translate>webreport.term.closed</span>
                    @switch (element.subStatus) {
                      @case (101) {
                        <span class="sub-status" translate>general.term.revision</span>
                      }
                      @case (102) {
                        <span class="sub-status" translate>general.term.storm</span>
                      }
                      @case (103) {
                        <span class="sub-status" translate>general.term.malfunction</span>
                      }
                    }
                  </div>
                }
                @case (3) {
                  <div class="status-box preparation-status" translate>webreport.term.preparation</div>
                }
              }
            </ion-col>
          </ion-row>
        }
      </div>
      @if (element.info) {
        <div class="content-div">
          <ion-row>
            <ion-col class="sub-title" translate>general.term.information</ion-col>
          </ion-row>
          <ion-row>
            <ion-col [innerHTML]="element.info.split('\n').join('<br>') | clickableUrl"></ion-col>
          </ion-row>
        </div>
      }
      @if (
        element.lengthMeter ||
        element.firstRide ||
        element.lastRide ||
        element.throughput ||
        element.travelTime ||
        element.duration ||
        element.elevation
      ) {
        <div class="content-div">
          <ion-row>
            <ion-col class="sub-title" translate>general.term.details</ion-col>
          </ion-row>
          @if (element.lengthMeter) {
            <ion-row>
              <ion-col>
                {{ ('general.term.length' | translate) + ': ' }}
              </ion-col>
              <ion-col>
                {{ element.lengthMeter + ' m' }}
              </ion-col>
            </ion-row>
          }
          @if (element.firstRide) {
            <ion-row>
              <ion-col>
                {{ ('general.term.firstRide' | translate) + ': ' }}
              </ion-col>
              <ion-col>
                {{ element.firstRide }}
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                {{ ('general.term.lastRide' | translate) + ': ' }}
              </ion-col>
              <ion-col>
                {{ element.lastRide }}
              </ion-col>
            </ion-row>
          }
          @if (element.throughput) {
            <ion-row>
              <ion-col>
                {{ ('general.term.throughput' | translate) + ': ' }}
              </ion-col>
              <ion-col>
                {{ element.throughput + ' Pers./Hr.' }}
              </ion-col>
            </ion-row>
          }
          @if (element.travelTime) {
            <ion-row>
              <ion-col>
                {{ ('general.term.travelTime' | translate) + ': ' }}
              </ion-col>
              <ion-col>
                {{ element.travelTime + ' Min.' }}
              </ion-col>
            </ion-row>
          }
          @if (element.duration) {
            <ion-row>
              <ion-col>
                {{ ('general.term.hikeDuration' | translate) + ': ' }}
              </ion-col>
              <ion-col>
                {{ element.duration | hoursMinutes }}
              </ion-col>
            </ion-row>
          }
          @if (element.elevation) {
            <ion-row>
              <ion-col>
                {{ ('general.term.elevation' | translate) + ': ' }}
              </ion-col>
              <ion-col>
                {{ element.elevation + ' m' }}
              </ion-col>
            </ion-row>
          }
        </div>
      }
      @if (element.contact || element.location || element.phone || element.email) {
        <div class="content-div contact">
          <ion-row>
            <ion-col class="sub-title" translate>general.term.contact</ion-col>
          </ion-row>
          @if (element.contact) {
            <ion-row>
              <ion-col>
                {{ element.contact }}
              </ion-col>
            </ion-row>
          }
          @if (element.location) {
            <ion-row>
              <ion-col>
                {{ element.location }}
              </ion-col>
            </ion-row>
          }
          @if (element.phone) {
            <ion-row>
              <ion-col size="1">
                <ion-icon name="call-outline"></ion-icon>
              </ion-col>
              <ion-col>
                <a [href]="'tel:' + element.phone">{{ element.phone }}</a>
              </ion-col>
            </ion-row>
          }
          @if (element.email) {
            <ion-row>
              <ion-col size="1">
                <ion-icon name="mail-outline"></ion-icon>
              </ion-col>
              <ion-col>
                <a [href]="'mailto:' + element.email">{{ element.email }}</a>
              </ion-col>
            </ion-row>
          }
        </div>
      }
      @if (element.operatingHoursEnabled) {
        <div class="content-div">
          <ion-grid class="operating-hours-table">
            <ion-row>
              <ion-col class="sub-title" translate>general.term.operatingHours</ion-col>
            </ion-row>
            @for (operatingHours of operatingHours$ | async; track operatingHours) {
              <ion-row [class.today]="operatingHours.isToday">
                <ion-col class="weekday">{{ operatingHours.weekday }}</ion-col>
                <ion-col class="date">{{ operatingHours.date }}</ion-col>
                <ion-col class="time">{{ operatingHours.time }}</ion-col>
              </ion-row>
            }
          </ion-grid>
        </div>
      }
      @if (element.website) {
        <div class="content-div contact">
          <ion-row>
            <ion-col class="sub-title" translate>general.term.website</ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="sis-global-text-overflow-ellipsis">
              <a [href]="element.website" target="_blank" rel="noreferrer noopener">{{ element.website }}</a>
            </ion-col>
          </ion-row>
          @if (showQrCode) {
            <ion-row>
              <ion-col>
                <qrcode
                  class="sis-asset-website-qr-code"
                  data-test="sis-asset-website-qr-code"
                  [qrdata]="element.website"
                  [errorCorrectionLevel]="'M'"
                  [elementType]="'svg'"
                  [margin]="0"
                  [width]="100"
                ></qrcode>
              </ion-col>
            </ion-row>
          }
        </div>
      }
    </ion-content>
  </div>
}
